/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earth_Day_2025_Donate_ContentInputs */

const en_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock the exclusive <b>Planet Guardian</b> with any donation plan!`)
};

const ar_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افتح قفل <b>حارس الكوكب</b> الحصري مع أي خطة تبرع!`)
};

const de_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schalte den exklusiven <b>Planet Guardian</b> mit jedem beliebigen Spendenplan frei!`)
};

const es_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Desbloquea al exclusivo <b>Guardián del planeta</b> con cualquier plan de donación!`)
};

const fr_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloquez l'exclusif <b>Gardien de la Planète</b> avec n'importe quel plan de don !`)
};

const it_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca l'esclusivo <b>Guardiano del pianeta</b> con qualsiasi piano di donazione!`)
};

const ja_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの寄付プランでも、限定植物「<b>プラネット・ガーディアン</b>」をアンロックできます！`)
};

const ko_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떤 기부 플랜으로든 한정 식물 '<b>행성 수호자</b>'를 잠금 해제하세요!`)
};

const pt_br_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueie a exclusiva <b>Guardiã do Planeta</b> com qualquer plano de doação!`)
};

const ru_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокируйте эксклюзивное растение <b>Хранитель планеты</b> с любым планом пожертвования!`)
};

const th_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อก "<b>ผู้พิทักษ์โลก</b>" สุดพิเศษด้วยแผนการบริจาคใดก็ได้!`)
};

const tr_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herhangi bir bağış planıyla özel <b>Gezegen Koruyucusu</b>'nun kilidini açın!`)
};

const zh_cn_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`捐赠任一方案即可解锁限定植物<b>守星木</b>！`)
};

const zh_tw_earth_day_2025_donate_content = /** @type {(inputs: Earth_Day_2025_Donate_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`捐贈任一方案即可獲得限定植物<b>守星木</b>！`)
};

/**
* | output |
* | --- |
* | "Unlock the exclusive <b>Planet Guardian</b> with any donation plan!" |
*
* @param {Earth_Day_2025_Donate_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_donate_content = /** @type {((inputs?: Earth_Day_2025_Donate_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Donate_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_donate_content(inputs)
	if (locale === "ar") return ar_earth_day_2025_donate_content(inputs)
	if (locale === "de") return de_earth_day_2025_donate_content(inputs)
	if (locale === "es") return es_earth_day_2025_donate_content(inputs)
	if (locale === "fr") return fr_earth_day_2025_donate_content(inputs)
	if (locale === "it") return it_earth_day_2025_donate_content(inputs)
	if (locale === "ja") return ja_earth_day_2025_donate_content(inputs)
	if (locale === "ko") return ko_earth_day_2025_donate_content(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_donate_content(inputs)
	if (locale === "ru") return ru_earth_day_2025_donate_content(inputs)
	if (locale === "th") return th_earth_day_2025_donate_content(inputs)
	if (locale === "tr") return tr_earth_day_2025_donate_content(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_donate_content(inputs)
	return zh_tw_earth_day_2025_donate_content(inputs)
});